module.exports = __webpack_public_path__ + "static/media/apple-pay-black.8431c63d.svg";